import styled from "styled-components";

export const Container = styled.div`
  margin: 2% 10%;
  padding-bottom: 10%;
  display: grid;
  gap: 0 3.5em;
  grid-template-columns: 1fr 2fr;
  justify-content: space-around;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: block;
    margin: 0 5%;
  }
`;
export const Display = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  gap: 0 1.3em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: block;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: block;
  }
`;

export const HeaderImage = styled.div`
  width: 100%;
  height: 10.1875rem;
  background: #bedfff;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    height: 8.0625rem;
  }
`;

export const BottomText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #6d6d6d;
  margin-bottom: 2em;
  margin-top: 4.6em;
  display: none;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: block;
  }
`;
export const HeroImage = styled.div`
  width: 40rem;
  height: 21.25rem;
  flex-shrink: 0;
  border-radius: 1.0625rem;
  background: #000;
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 1.25em;
  align-items: center;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
   
  }
  div {
    position: absolute;
    bottom: 2em;
    left: 50%;
    transform: translateX(-50%);
    color: #000;
    text-align: center;
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 1em;
    width: 14.3125rem;
    height: 2rem;
    flex-shrink: 0;
    border-radius: 0.375rem;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    margin-bottom: 1.2em;
    height: 21.0625rem;
    flex-shrink: 0;
  }
`;

export const SmallDiv = styled.div`
  width: 40rem;
  flex-shrink: 0;
  border-radius: 0.8125rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
  gap: 1em 1.3em;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    /* display: block; */
    width: 100%;
    gap: 0 5%;
  }
`;
export const NewProducts = styled.div`
  width: 19.4375rem;
  height: 13.5rem;
  flex-shrink: 0;
  border-radius: 0.8125rem;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
  border: ${(props: any) => (props.isImportant ? "4px solid #351182" : "none")};
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  div {
    position: absolute;
    bottom: 1em;
    left: 50%;
    color: #000;
    text-align: center;
    font-size: 0.9rem;
    transform: translateX(-50%);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 0.7em;
    width: 18.0625rem;
    flex-shrink: 0;
    border-radius: 0.375rem;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    margin-bottom: 1.2em;
    div {
      width: 90%;
      font-size: 0.5em;
    }
  }
`;
